import { api } from "./authService";

export interface InstitutionTypeItem {
  id: string;
  name: string;
  code: string;
  description?: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export const institutionTypeService = {
  getInstitutionTypes: async (params?: { search?: string; is_active?: boolean }): Promise<{ results: InstitutionTypeItem[] } | InstitutionTypeItem[]> => {
    const response = await api.get("/master/institution-types/", { params });
    return response.data;
  },

  createInstitutionType: async (data: { name: string; code: string; description?: string; is_active?: boolean }): Promise<InstitutionTypeItem> => {
    const response = await api.post("/master/institution-types/", data);
    return response.data;
  },

  updateInstitutionType: async (id: string, data: Partial<{ name: string; code: string; description: string; is_active: boolean }>): Promise<InstitutionTypeItem> => {
    const response = await api.patch(`/master/institution-types/${id}/`, data);
    return response.data;
  },

  deleteInstitutionType: async (id: string): Promise<void> => {
    await api.delete(`/master/institution-types/${id}/`);
  },
};
